export const gitCommit = '955b2079'
